import CtaBarButton from '../base/cta-bar-button';
import {
  brandColor,
  getClassTextForColor,
  getEditorColor,
} from '../../util/ColorUtil';
import React, { useState } from 'react';
import FacilityModal from '../modal/FacilityModal';
import LargeCtaButton from '../base/large-cta-button';
import {
  getEditorColors,
  getEditorColorsHex,
  isEmpty,
  isItUndefined,
  modifyLinks,
} from '../../util/DataUtil';
import { getObjectValueByMachineName } from '../../util/ObjectUtil';
import { cleanHTML } from '../utils/htmlUtils';
import {useRouter} from "next/router";

const DataPromo = ({ data, lang, global }) => {
  const [marketoTrigger, setMarketoTrigger] = useState(false);
  let button = data?.field_large_cta_button[0]
    ? data?.field_large_cta_button[0].large_cta_button
    : {};
  const emphasizedTextColorHex = getEditorColorsHex(
    isItUndefined(data?.field_formatted_title),
    isItUndefined(data?.field_title_color),
    isItUndefined(data?.field_subtitle_color),
    isItUndefined(data?.field_description)
  ).filter((x) => x)[0];
  const emphasizedTextColor = getEditorColors(
    isItUndefined(data?.field_formatted_title),
    isItUndefined(data?.field_title_color),
    isItUndefined(data?.field_subtitle_color),
    isItUndefined(data?.field_description)
  ).filter((x) => x)[0];

  const buttonsPosition =
    data?.field_button_left_or_right[0]?.value === '0' ? 'left' : 'right';
  const items = data?.field_data_promo_stats?.stats_coloured_fields_type;
  const { locale } = useRouter();

  const renderItems = () => {
    return items.map((item, index) => {
      return (
        <div className={'item'} key={`data-promo-key-${item?.field_description_formatted?.[0]?.value || index}`}>
          <span
            dangerouslySetInnerHTML={{
              __html: getObjectValueByMachineName(
                item?.field_description_formatted[0]?.value,
                global
              ),
            }}
            className={'number'}
          />
          <span
            dangerouslySetInnerHTML={{
              __html: getObjectValueByMachineName(
                item?.field_value_formatted[0]?.value,
                global
              ),
            }}
            className={'description'}
          />
        </div>
      );
    });
  };

  return (
    <div
      className={
        'data-promo ' +
        getClassTextForColor(data?.field_background_color[0]?.value)
      }
      style={{
        backgroundColor: brandColor(data?.field_background_color[0]?.value),
      }}
    >
      <div className={'inner-container'}>
        <div className={'top'}>
          {data?.field_title_color[0]?.value && (
            <span
              className={`title ${emphasizedTextColor ? emphasizedTextColor : ''}`}
              dangerouslySetInnerHTML={{
                __html: cleanHTML(
                  modifyLinks(data?.field_title_color[0]?.value, locale)
                ),
              }}
            />
          )}
          {data?.field_subtitle_color[0]?.value && (
            <span
              className={`subtitle ${emphasizedTextColor ? emphasizedTextColor : ''}`}
              dangerouslySetInnerHTML={{
                __html: cleanHTML(
                  modifyLinks(data?.field_subtitle_color[0]?.value, locale)
                ),
              }}
            />
          )}
        </div>
        <div className={'bottom ' + buttonsPosition}>
          <div className={'text-cta'}>
            {data?.field_formatted_title[0]?.value && (
              <span
                className={`section-title ${emphasizedTextColor ? emphasizedTextColor : ''}`}
                dangerouslySetInnerHTML={{
                  __html: cleanHTML(
                    modifyLinks(data?.field_formatted_title[0]?.value)
                  ),
                }}
              />
            )}
            {data?.field_description[0]?.value && (
              <span
                className={`section-description ${emphasizedTextColor ? emphasizedTextColor : ''}`}
                dangerouslySetInnerHTML={{
                  __html: cleanHTML(
                    modifyLinks(data?.field_description[0]?.value)
                  ),
                }}
              />
            )}
            {data?.field_cta_bar_button_selection?.length > 0 && (
              <CtaBarButton
                blockTypeClass={'data-promo'}
                bgColor={getEditorColor(
                  brandColor(data?.field_background_color[0]?.value)
                )}
                setMarketoTrigger={setMarketoTrigger}
                data={data?.field_cta_bar_button_selection[0].cta_bar_button}
                pathname={true}
              />
            )}

            {items?.length > 0 && (
              <div className={'items'}>{renderItems()}</div>
            )}
          </div>
          {!isEmpty(button) && (
            <LargeCtaButton
              borderColor={
                emphasizedTextColorHex ? emphasizedTextColorHex : '#1F00FF'
              }
              data={button}
            />
          )}
        </div>
        {marketoTrigger && (
          <FacilityModal
            lang={lang}
            global={global}
            setTrigger={setMarketoTrigger}
            trigger={marketoTrigger}
          >
            {
              data?.field_cta_bar_button_selection[0]?.cta_bar_button
                ?.field_marketo_blocks[0]?.marketo_form_facility_block_type
            }
          </FacilityModal>
        )}
      </div>
    </div>
  );
};

export default DataPromo;
